



























































import VueOptions from '@utils/VueOptions'
import ShippingAreaFields from '@ui/FormBuilder/ResourceFields/ShippingAreaFields.coffee'
import FormField from '@ui/FormBuilder/FormField'

settings =
  name: 'ShipppingAreaForm'

  vue:
    props: ['wizard', 'form', 'actions']

    components: {
      FormField,
    }

    computed:
      fieldKeys: ->
        [
          'contact_name'
          'contact_phone'
          'address'
          'street_2'
          'attention_to'
          'accepts_pallets'
          'max_pallet_count'
          'loading_dock_available'
          'truck_requires_lift_gate'
          'property_type'
          'other_property_type'
          'delivery_window'
          'delivery_timeframe'
          'special_delivery_instructions'
        ]

      formFields: ->
        fields = {}
        fields[key] = @shippingAreaFields.fields[key] for key in @fieldKeys
        fields

      contextForShippingAreaFields: ->
        # options:
        #   venue_type: @toSelectOptions(@$store.marketplace?.listing?.venue_types)
        #   primary_team: @toSelectOptions(@$store.marketplace?.brand?.categories)

      shippingAreaFields: ->
        ShippingAreaFields(@contextForShippingAreaFields)

    methods:
      saveField: (fieldName) ->
        if @actions?.saveField?
          @actions.saveField fieldName
        else
          @wizard?.saveField? fieldName

export default VueOptions.vue settings
